import { ExerciseConfigExecutionTypeEnum, ExerciseDTO } from '@/generated';
import { exerciseDetailsListStyle, exerciseDetailsListSubheaderStyle, exerciseDetailsPaperListElevation, exerciseDetailsPaperListStyle } from '@/styles';
import { Box, List, ListItem, ListSubheader, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

export const ExerciseInfoList = (props: { exercise: ExerciseDTO }) => {
  const { exercise } = props;
  const config = exercise.config;
  const executionType = config.executionType;
  const limbTracking = { label: 'Limb tracking', value: config.trackPerSide ? 'Yes' : 'No' };
  const limbTrackingValues = exercise.isUniLateral ? [limbTracking] : [];
  const weightValues = config.weight !== undefined && config.weight > 0 ? [{ label: 'Weight', value: config.weight }] : [];
  const bodyweightPercentageValues =
    config.bodyweightPercentage !== undefined ? [{ label: 'Bodyweight percentage', value: `${config.bodyweightPercentage}%` }] : [];
  const executionTypeValue = {
    label: 'Execution type',
    value: executionType === ExerciseConfigExecutionTypeEnum.Reps ? 'Reps' : executionType === ExerciseConfigExecutionTypeEnum.Duration ? 'Duration' : 'Intervals',
  };
  const executionValues =
    executionType === ExerciseConfigExecutionTypeEnum.Reps
      ? [{ label: 'Repetitions', value: config.value ?? '-' }, ...weightValues, ...limbTrackingValues]
      : executionType === ExerciseConfigExecutionTypeEnum.Duration
        ? [{ label: 'Duration', value: config.value !== undefined ? `${config.value} seconds` : '-' }, ...weightValues, ...limbTrackingValues]
        : [
            ...weightValues,
            ...limbTrackingValues,
            { label: 'Init time', value: config.timing?.initTimeSeconds !== undefined ? `${config.timing.initTimeSeconds} seconds` : '-' },
            ...(exercise.isUniLateral && config.trackPerSide
              ? [{ label: 'Switch time', value: config.timing?.switchPauseSeconds !== undefined ? `${config.timing.switchPauseSeconds} seconds` : '-' }]
              : []),
          ];
  const values = [...bodyweightPercentageValues, executionTypeValue, ...executionValues];
  const intervals = config.timing?.intervals ?? [];

  return (
    <Paper sx={exerciseDetailsPaperListStyle} elevation={exerciseDetailsPaperListElevation}>
      <List sx={exerciseDetailsListStyle} component={'nav'}>
        <ListSubheader sx={exerciseDetailsListSubheaderStyle}>Info</ListSubheader>
        {values.map((item, index) => (
          <ListItem key={item.label} dense sx={{ px: 1.5, pt: index === 0 ? 1.25 : 0.25, pb: 0.25, gap: 1, justifyContent: 'space-between' }}>
            <Typography color="text.secondary" sx={{ fontSize: '0.8rem' }}>
              {item.label}
            </Typography>
            <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, textAlign: 'right' }}>{item.value}</Typography>
          </ListItem>
        ))}
        {executionType === ExerciseConfigExecutionTypeEnum.Intervals && (
          <Box sx={{ px: 1.5, pt: 1, pb: 0.75 }}>
            <Table size="small" aria-label="Exercise intervals">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell align="right">Duration</TableCell>
                  <TableCell align="right">Pause</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {intervals.map((interval, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell align="right">{interval.durationSeconds}s</TableCell>
                    <TableCell align="right">{interval.pauseAfterSeconds ?? 0}s</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </List>
    </Paper>
  );
};
